import { render, staticRenderFns } from "./Associate.vue?vue&type=template&id=8ad9f548&scoped=true"
import script from "./Associate.vue?vue&type=script&lang=js"
export * from "./Associate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad9f548",
  null
  
)

export default component.exports